import "../scss/main.scss";

import "./components/autocomplete";
import "./components/accordion";
import "./components/cookie-banner";
import "./components/modal";
import "./components/nav";
import "./components/nav-dropdown";
import "./components/nav-menu";
import "./components/text-truncate";
import "./components/video";

import "./modules/promo-banner";